// extracted by mini-css-extract-plugin
export default {"serviceTextContainer":"ServiceText_serviceTextContainer__4ILKR","serviceHeader":"ServiceText_serviceHeader__jwyBE","serviceText":"ServiceText_serviceText__d5CXf"};